const CustomerCardStyles = { 
    customerCard: {
    padding: "15px 30px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    border: "1px solid #C9E1EC",
    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
    marginBottom: "10px",
  },
  containerOne: {
    display: "flex",
    alignItems: "center",
  },
}

export default CustomerCardStyles